import React from 'react';
import { CaseNote } from '../../services/api';
import { Plus } from 'lucide-react';
import './NotesTab.css';

interface NotesTabProps {
  notes: CaseNote[];
  onAddNote: () => void;
  formatDateTime: (date: string) => string;
}

const NotesTab: React.FC<NotesTabProps> = ({ notes, onAddNote, formatDateTime }) => {
  return (
    <div className="notes-list">
      <div className="notes-header">
        <button onClick={onAddNote} className="add-note-btn">
          <Plus size={18} />
          Add Note
        </button>
      </div>
      {!notes || notes.length === 0 ? (
        <div className="empty-state">No notes available</div>
      ) : (
        notes.map((note) => (
          <div key={note.noteId} className="note-card">
            <div className="note-header">
              <span className="note-author">{note.authorName}</span>
              <span className="note-date">{formatDateTime(note.createdAt)}</span>
            </div>
            {note.typeTag && <span className="note-tag">{note.typeTag}</span>}
            <div className="note-body">{note.body}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default NotesTab;

